/* eslint-disable @typescript-eslint/no-unused-vars */
import { useRef } from "react";
import type { IUseAudioTranscription } from "@/hooks/transcriber/useAudioTranscriptionFactory";

export const useAudioTranscriptionDisabled = (): IUseAudioTranscription => {
  const audioStreamRef = useRef<MediaStream | null>(null);
  const finished = true;
  const isProviderReady = true;
  const transcription = "";
  const finishSession = (): void => {};
  const reset = (): void => {};
  const pauseStream = (): void => {};
  const setStream = (_stream: MediaStream): void => {};

  return {
    audioStream: audioStreamRef.current,
    setStream,
    transcription: transcription,
    finishSession,
    finished,
    reset,
    pauseStream,
    isProviderReady,
  };
};
